import React from 'react';
import './Accessories.scss';
import Slider from 'react-slick';
import Button from '../@redantler/redantler-npm-button-react';
import { COLORS } from '../../constants/colors';
import AccessoriesSlide from './AccessoriesSlide/AccessoriesSlide';
import NextArrowButton from '../UI/Icons/NextArrowButton';
import PrevArrowButton from '../UI/Icons/PrevArrowButton';

/**
 * Renders the accessories module
 * @param {string} title
 * @param {array} products
 * @param {function} addToCart
 * @returns {JSX.Element}
 * @constructor
 */
const Accessories = ({ title, products, addToCart }) => {
  const settings = {
    dots: false,
    infinite: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    variableWidth: true,
    prevArrow: (
      <Button addClass="c-accessories__arrow c-accessories__prev">
        <PrevArrowButton color={COLORS.black} />
      </Button>
    ),
    nextArrow: (
      <Button addClass="c-accessories__arrow c-accessories__next">
        <NextArrowButton color={COLORS.black} />
      </Button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
          infinite: true,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          variableWidth: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          variableWidth: true,
        },
      },
    ],
  };

  return (
    <div id="c-accessories" className="c-accessories background-color-orange">
      <div className="c-accessories__intro">
        <div className="c-accessories__intro--inner">
          <div className="c-accessories__title color-black h2-roobert">
            <h2>{title}</h2>
          </div>
        </div>
      </div>
      <div className="c-accessories__slides-container-fluid">
        <div className="c-accessories__slides-container">
          <Slider className="c-accessories__slides" {...settings}>
            {products.map((product) => (
              <AccessoriesSlide product={product} addToCart={addToCart} />
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Accessories;
